export default __webpack_public_path__ + "static/media/874.6488ab88.png";